var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViolence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.999 48",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(190, 33, 38)",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.496 41a1.5 1.5 0 0 0-1.5 1.5v3.999a1.5 1.5 0 0 0 3 0V42.5a1.5 1.5 0 0 0-1.5-1.5zM23.498 34.003h-4a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5zM12.502 23.001a1.5 1.5 0 0 0-1.5 1.5V28.5a1.5 1.5 0 0 0 3 0v-3.999a1.5 1.5 0 0 0-1.5-1.5zM6.999 35.497a1.5 1.5 0 0 0-1.5-1.5H1.5a1.5 1.5 0 0 0 0 3h3.999a1.5 1.5 0 0 0 1.5-1.5zM18.56 39.436a1.5 1.5 0 1 0-2.122 2.122l3.003 3.003a1.5 1.5 0 1 0 2.122-2.122zM18.556 31.564l3.004-3.003a1.5 1.5 0 0 0-2.122-2.122l-3.003 3.003a1.5 1.5 0 1 0 2.121 2.122zM6.441 31.563a1.5 1.5 0 0 0 2.121-2.12L5.56 26.438a1.5 1.5 0 0 0-2.122 2.122zM6.441 39.436L3.438 42.44a1.5 1.5 0 0 0 2.122 2.122l3.003-3.003a1.5 1.5 0 0 0-2.122-2.122zM34.999 10c-7.411 0-13 5.16-13 12a2 2 0 0 0 4 0 7.449 7.449 0 0 1 4-6.745V46a2 2 0 0 0 4 0V31h2v15a2 2 0 0 0 4 0V15.255a7.449 7.449 0 0 1 4 6.745 2 2 0 0 0 4 0c0-6.84-5.589-12-13-12z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.999,
    cy: 4,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolence);
export default __webpack_public_path__ + "static/media/violence.9b2eadda8185478a381a0eef47dc42ac.svg";
export { ForwardRef as ReactComponent };